import { clone } from 'lodash';

import { requestIdleCallbackPolyfill } from '../utils/requestIdleCallbackPolyfill';
import { ref } from '@vue/composition-api';

const renderOrder = [
  'left-content',
  'header-tab',
  // 'assignee',
  'right-content',
  // 'description',
  // 'rich-text',
  'relationship',
  'subtask',
  'attachment',
  'comments',
  'footer-area',
  'plugin',
  'activities'
];

export const useFieldRenderScheduler = () => {
  const localRenderOrder = ref(clone(renderOrder));
  let rendering = false;
  const callback = () => {
    const code = localRenderOrder.value.shift();
    if (code) {
      if (localRenderOrder.value.length) {
        requestIdleCallbackPolyfill(callback, { timeout: 500 });
      } else {
        rendering = false;
      }
    }
  };

  return {
    lazyRenderFields: localRenderOrder,
    restart: () => {
      if (rendering) {
        return;
      }
      rendering = true;
      localRenderOrder.value = clone(renderOrder);
      requestIdleCallbackPolyfill(callback, { timeout: 500 });
    }
  };
};
